import type { ChangeEvent, Ref } from 'react'
import { forwardRef } from 'react'

import TextField from '@space-core/components/form/textField'

import styled from 'styled-components'

export type InputProps = {
  placeholder: string
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const Input = styled(TextField)`
  outline: none;
  appearance: none;
  padding: 0 !important;
  background-color: var(--bg-primary) !important;
  border: solid 0 transparent !important;
  border-width: 0;

  &:focus {
    background-color: var(--bg-primary) !important;
    border: thin solid var(--gray-200) !important;
    outline: none;
  }
`

const InputField = ({ onChange, placeholder, value }: InputProps, ref: Ref<HTMLInputElement>) => {
  return (
    <Input
      type='text'
      name='search'
      aria-label='search'
      onChange={onChange}
      placeholder={placeholder}
      id='search'
      ref={ref}
      value={value}
      data-test='input-search'
      autoComplete='off'
    />
  )
}

export default forwardRef(InputField)
